<template>
    <div class="input-button">
        <div :class="styleClasses" class="d-flex align-items-center justify-content-between text-nowrap btn-outer">
            <button class="button flex-grow-1 text-left" @click="didClick">
                <slot></slot>
            </button>
            <button v-if="icon !== 'none'" :class="iconClasses" @click="didClick('inner', $event)">
                &nbsp;
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'InputButton',
        props: {
            icon: {
                type: String,
                default: 'none',
            },
            type: {
                type: String,
                default: 'solid',
            },
            value: {
                type: String,
                default: '',
            },
            useClickEventForAll: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            styleClasses() {
                const className = {
                    div: true,
                };
                className[this.type] = true;
                return className;
            },
            iconClasses() {
                const className = {
                    button: true,
                };
                className[this.icon] = true;
                return className;
            },
        },
        methods: {
            didClick(mode, event) {
                if (!this.useClickEventForAll && typeof mode === 'string') {
                    this.$emit(`click-${mode}`);
                    if (event instanceof MouseEvent) {
                        event.stopPropagation();
                    }
                    return;
                }
                this.$emit('click');
            },
        },
    };
</script>
